import { Community } from "../../types/Community";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import { stripLegacyCommunityReelCreatorConfig } from "./reelCreatorConfig";
import { stripLegacyCommunityMedia } from "./communityMedia";

export const updateCommunity = async (community: Community): Promise<void> => {
  if (!community.id) {
    throw new Error("Community id is required to update");
  }

  try {
    await firestore
      .collection(DB_PATH.COMMUNITY)
      .doc(community.id)
      .set(
        stripLegacyCommunityMedia(
          stripLegacyCommunityReelCreatorConfig(community as unknown as Record<string, unknown>)
        ),
        { merge: true }
      );
  } catch (error) {
    console.error("Error updating community", error);
  }
};
